import PropTypes from "prop-types";
import React, { Component, useState, useEffect } from "react";
import { Button } from "react-bootstrap";

import MainPage from "../components/MainPage.react";
import EulaActions from "../actions/EulaActions";
import ContentActions from "../actions/ContentActions";
import ContentStore from "../stores/ContentStore";
import EulaStore from "../stores/EulaStore";
import { browserHistory } from "react-router";

import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

const signClick = (e) => {
  EulaActions.signEula();
  e.preventDefault();
};

const Eula = () => {
  const eulaContentId = EulaStore.eulaContentId();
  const [content, setContent] = useState(null);

  useEffect(() => {
    const subscription = ContentStore.addListener(() => {
      setContent(
        ContentStore.getState().getIn(["entries", eulaContentId], null)
      );
    });
    ContentActions.loadPage(eulaContentId);
    return () => {
      subscription.remove();
    };
  }, [eulaContentId]); // Only run this if eula content ID happens to change

  const contentBlock = content ? (
    documentToReactComponents(content.get("fields").get("content").toJS())
  ) : (
    <p>Loading EULA...</p>
  );

  return (
    <MainPage className="eulaPage">
      {contentBlock}
      <Button onClick={signClick}>Agree</Button>
      <Button
        onClick={(e) => {
          browserHistory.push("/logout");
        }}
      >
        Leave
      </Button>
    </MainPage>
  );
};

export default Eula;
